// extracted by mini-css-extract-plugin
export var body = "_jl-0";
export var sectionHeader = "_jl-4";
export var shortcutColumns = "_jl-2";
export var shortcutList = "_jl-1";
export var shortcutSection = "_jl-3";